import { Gallery } from './components/Gallery';
import { LandingPage } from './components/LandingPage';
import { Team } from './components/Team';

import React, { createContext, useContext, useState, ReactNode } from 'react';

interface YearContextType {
  currentYear: number;
  setCurrentYear: React.Dispatch<React.SetStateAction<number>>;
}

const YearContext = createContext<YearContextType | undefined>(undefined);

interface YearProviderProps {
  children: ReactNode;
}

export const YearProvider: React.FC<YearProviderProps> = ({ children }) => {
  const [currentYear, setCurrentYear] = useState<number>(0);

  return (
    <YearContext.Provider value={{ currentYear, setCurrentYear }}>
      {children}
    </YearContext.Provider>
  );
};

export const useYear = (): YearContextType => {
  const context = useContext(YearContext);
  if (!context) {
    throw new Error('useYear must be used within a YearProvider');
  }
  return context;
};


export const About: React.FC = () => {
  return (
    <YearProvider>
      <LandingPage />
      <Gallery />
      <Team />
    </YearProvider>
  );
};